import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons, FooterError } from '@/design_system/Footer';
import { useCompleteSelfHandledTransit } from '@/models/article';

import { ArticleActionProps } from './ArticleActions';

export const CompleteSelfHandledTransitAction = ({ article, onActionDone }: ArticleActionProps) => {
  const { t } = useLingui();
  const [apiError, setApiError] = useState('');

  const {
    mutateAsync: completeSelfHandledTransit,
    isPending: isPendingCompleteSelfHandledTransit,
  } = useCompleteSelfHandledTransit({
    articleId: article.id,
  });

  const handleComplete = async () => {
    try {
      await completeSelfHandledTransit();
      onActionDone();
    } catch (err: any) {
      console.error(err);
      setApiError(
        (err.message as string) ?? t({ id: '_general.error.unknown', message: 'Unknown error' })
      );
    }
  };

  return (
    <Footer>
      {!!apiError && <FooterError>{apiError}</FooterError>}
      <FooterButtons>
        <Button
          variant="primary"
          onPress={handleComplete}
          isLoading={isPendingCompleteSelfHandledTransit}
        >
          <Trans id="article.actions.complete_self_handled_transit.label">Confirm reception</Trans>
        </Button>
      </FooterButtons>
    </Footer>
  );
};
